import { render, staticRenderFns } from "./NewCustomerModal.vue?vue&type=template&id=724274dc"
import script from "./NewCustomerModal.vue?vue&type=script&lang=js"
export * from "./NewCustomerModal.vue?vue&type=script&lang=js"
import style0 from "./NewCustomerModal.vue?vue&type=style&index=0&id=724274dc&prod&lang=postcss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports